const ServerEvents = {
    "categoryAttributeEventChange" : "srv-category-attribute-event-change",
    "delayedTaskComplete" : "srv-delayed-task-complete",
    "dictionaryChange" : "srv-dictionary-change",
    "domainVerificationChanged" : "srv-domain-verification-changed",
    "dynamicAttributeEventChange" : "srv-dynamic-attribute-event-change",
    "dynamicColumnEventChange" : "srv-dynamic-column-event-change",
    "dynamicDictionaryEventChange" : "srv-dynamic-dictionary-event-change",
    "dynamicEntityChange" : "srv-dynamic-entity-change",
    "dynamicEntityEventChange" : "srv-dynamic-entity-event-change",
    "formsChange" : "srv-forms-change",
    "newBackgroundTaskEvent" : "srv-new-background-task-event",
    "newDocumentEvent" : "srv-new-document-event",
    "newInquiryMessageEvent" : "srv-new-inquiry-message-event",
    "newInspirationMessageEvent" : "srv-new-inspiration-message-event",
    "newNotification" : "srv-new-notification",
    "newSupplierMessageEvent" : "srv-new-supplier-message-event",
    "observableEntityChange" : "srv-observable-entity-change",
    "permissionsChanged" : "srv-permissions-changed",
    "prestaShopIntegrationSentEvent" : "srv-presta-shop-integration-sent-event",
    "progressInfo" : "srv-progress-info",
    "pushHealthcheckEvent" : "srv-push-healthcheck-event",
    "refreshList" : "srv-refresh-list",
    "sessionChanged" : "srv-session-changed",
    "sessionTerminated" : "srv-session-terminated",
    "sessionTimeout" : "srv-session-timeout",
    "shutdownMessage" : "srv-shutdown-message",
    "subiektIntegrationSentEvent" : "srv-subiekt-integration-sent-event",
    "subscribedMessage" : "srv-subscribed-message",
    "subscriptionStatusChanged" : "srv-subscription-status-changed",
}
window["ServerEvents"] = ServerEvents;
export default ServerEvents;